import React from 'react';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { SolutionWithActive } from '../../_types';
import { PowerSettingsNewOutlined } from '@mui/icons-material';
import { neutral, primary } from '_lex/_foundations/phxColors';

interface ListPolicyProps {
  // Add any props specific to policy management if needed
}

const InactiveState: React.FC<ListPolicyProps> = () => {
  return (
    <CardContent>
      <Box sx={{ py: { xs: 2, sm: 4, md: 6 }, display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            position: 'relative',
            width: { xs: 120, sm: 160, md: 200 },
            height: { xs: 80, sm: 100, md: 120 },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: `radial-gradient(circle at center, ${primary[50]} 0%, transparent 60%)`,
            borderRadius: 3,
          }}
        >
          <Box
            sx={{
              width: { xs: 32, sm: 36, md: 40 },
              height: { xs: 32, sm: 36, md: 40 },
              borderRadius: '50%',
              backgroundColor: '#FFF',
              border: '1px solid',
              borderColor: neutral[200],
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: `0 8px 24px ${primary[700]}22`,
            }}
          >
            <PowerSettingsNewOutlined sx={{ fontSize: { xs: 16, sm: 18, md: 20 }, color: primary[700] }} />
          </Box>
        </Box>
      </Box>

      <Typography
        variant='h5'
        sx={{ textAlign: 'center', mb: { xs: 1.5, md: 2 }, fontSize: { xs: 20, md: 24 } }}
      >
        {t('manageSolutions.inactiveState.title', 'Inactive')}
      </Typography>
      <Typography
        variant='bodyLg'
        sx={{ textAlign: 'center', color: neutral[600], fontSize: { xs: 14, md: 16 } }}
      >
        {t('manageSolutions.inactiveState.subtitle', 'Edit settings to activate this product')}
      </Typography>
    </CardContent>
  );
};

export default InactiveState;
